import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getWeeklyPlannerTemplateByCourseQuery,
  getWeeklyPlannerTemplateSectionsQuery,
  getCalendarEventsQuery,
  getOrganizationTemplatesWithTypeQuery,
  getCourseAcademicYearsQuery,
  getPlatformCalendarEventItemsQuery,
} from "./ClassPlannersQueries";
import { classPlannerFragment } from "./ClassPlannersFragments";

export const getWeeklyPlannerTemplateFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getWeeklyPlannerTemplateByCourseQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const writeWeeklyPlannerTemplatesToCache = ({ data, variables }) => {
  try {
    client.writeQuery({
      query: getWeeklyPlannerTemplateByCourseQuery,
      variables,
      data,
    });
  } catch (e) {
    console.warn(e);
  }
};

export const getWeeklyPlannerFragmentFromCache = ({ id, variables }) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `WeeklyPlannerTemplate:${id}`,
      fragment: classPlannerFragment.classPlannerItemFragment,
      fragmentName: "classPlannerItem",
      variables,
    });
  } catch (e) {
    console.warn(e);
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getWeeklyPlannerTemplateSectionsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getWeeklyPlannerTemplateSectionsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const readWeeklyPlannerTemplateSectionFragment = ({ id, variables }) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `WeeklyPlannerSection:${id}`,
      fragment: classPlannerFragment.weeklyPlannerSectionFragment,
      fragmentName: "weeklyPlannerSectionItem",
      variables,
    });
  } catch (e) {
    console.warn(e);
    return {};
  }

  if (queryData != null) return queryData;
  else return {};
};

export const writeWeeklyPlannerTemplateSectionFragmentToCache = ({
  id,
  data,
  variables,
}) => {
  try {
    return client.writeFragment({
      id: `WeeklyPlannerSection:${id}`,
      fragment: classPlannerFragment.weeklyPlannerSectionFragment,
      fragmentName: "weeklyPlannerSectionItem",
      data,
      variables,
    });
  } catch (err) {
    console.warn(err);
    return {};
  }
};

export const getCalendarEventsFromCache = ({
  rangeBeginStartDate,
  rangeEndStartDate,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCalendarEventsQuery,
      variables: {
        rangeBeginStartDate,
        rangeEndStartDate,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "school", {});
  else return {};
};

export const getPlatformCalendarEventItemsCache = ({
  rangeBeginStartDate,
  rangeEndStartDate,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getPlatformCalendarEventItemsQuery,
      variables: {
        rangeBeginStartDate,
        rangeEndStartDate,
        filters: {
          isFullDayEvent: true,
        },
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) {
    const data = _.get(queryData, "platform.calendarEventItems");
    const calendarEvents = _.map(data, event => {
      const gradesArray = event?.associatedEntities;
      return {
        ...event,
        grades: _.map(gradesArray, ({ id }) => id),
      };
    });
    return { calendarEvents };
  } else return {};
};

export const getOrganizationTemplatesWithTypeFromCache = ({ id, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationTemplatesWithTypeQuery,
      variables: {
        id,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getCourseAcademicYearsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseAcademicYearsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};
